const topics = [
  { name: '暑期档热映', heat: '980万讨论', icon: 'ri-sun-line', color: 'text-orange-500' },
  { name: '悬疑剧场', heat: '760万讨论', icon: 'ri-search-eye-line', color: 'text-purple-500' },
  { name: '国产剧推荐', heat: '850万讨论', icon: 'ri-tv-2-line', color: 'text-red-500' },
  { name: '韩剧追更', heat: '620万讨论', icon: 'ri-heart-pulse-line', color: 'text-pink-500' },
  { name: '动漫新番', heat: '540万讨论', icon: 'ri-rocket-2-line', color: 'text-blue-500' },
  { name: '高分纪录片', heat: '380万讨论', icon: 'ri-earth-line', color: 'text-green-500' },
  { name: '经典老片', heat: '450万讨论', icon: 'ri-film-line', color: 'text-amber-500' },
  { name: '综艺名场面', heat: '710万讨论', icon: 'ri-emotion-laugh-line', color: 'text-rose-500' },
  { name: '动作大片', heat: '590万讨论', icon: 'ri-fire-line', color: 'text-red-600' },
  { name: '午夜剧场', heat: '320万讨论', icon: 'ri-moon-line', color: 'text-indigo-500' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            大家都在聊
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">
            发现当下最热门影视话题，加入讨论找到同好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-white hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 flex items-center justify-center`}>
                <i className={`${topic.icon} text-lg ${topic.color}`}></i>
              </div>
              <div className="text-left">
                <div className="text-sm font-medium text-foreground-800 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                  {topic.name}
                </div>
                <div className="text-xs text-foreground-400">{topic.heat}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}